import {
  AddIcon,
  ChevronDownIcon,
  DeleteIcon,
  EditIcon,
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  useColorModeValue,
  useDisclosure,
  Text,
} from "@chakra-ui/react";
import Card from "common/components/card/Card";
import Spinner from "common/components/spinner/Spinner";
import { constant } from "common/constant";
import { useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getApi } from "common/services/api";
import { HasAccess } from "../../utils/accessUtils";
import CustomView from "common/utils/customView";
import { useLocation } from "react-router-dom";
import ViewEdit from "../viewEdit";
import Overview from "../viewEdit/overview";
import { deleteManyApi } from "common/services/api";
import ColumnsTable from "services/Crm/components/contact/ColumnsTable";
import TaskColumnsTable from "services/Crm/components/task/ColumnsTable";
import MeetingColumnsTable from "common/modules/meeting/ColumnsTable";
import PhoneCall from "services/Crm/components/contact/phonCall";
import { crmConstant } from "services/Crm/constant";
import AddPhoneCall from "common/modules/phoneCall/AddPhoneCall";
import AddEmailHistory from "services/Crm/components/emailHistory/AddEmail";
import Attachment from "../viewEdit/attachment";
import DynamicModel from "common/components/dynamicModel";
import { postApi } from "common/services/api";
import { useDispatch } from "react-redux";
import { getContactList } from "common/redux/reducers/contactLeadSlice";
import { useSelector } from "react-redux";

const View = () => {
  const param = useParams();

  const user = JSON.parse(localStorage.getItem("user"));

  const [columns, setColumns] = useState([]);
  const [dataColumn, setDataColumn] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);

  const [isShowDynamicModel, setIsShowDynamicModel] = useState({
    type: "",
    isShow: false,
  });
  const [tableColumns, setTableColumns] = useState([]);
  const buttonbg = useColorModeValue("gray.200", "white");
  const textColor = useColorModeValue("gray.500", "white");
  const [isModelDataSubmitLoading, setIsModelDataSubmitLoading] =
    useState(false);
  const [data, setData] = useState();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [edit, setEdit] = useState(false);
  const [deleteModel, setDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [action, setAction] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const module = location?.state?.module;
  const size = "lg";
  const isEdit = location.state?.isEdit || false;
  const pathName = (name) => {
    return `/crm/${name?.replace(/ /g, "-")}`;
  };
  const hash = window.location.hash;
  const path = hash?.replace("#", "").split("/");
  const title = path[2] ? path[2]?.replace(/-/g, " ") : "";
  const [contactList, setContactList] = useState([]);
  const [moduleData, setModuleData] = useState({});
  const [moduleId, setModuleId] = useState("");
  const [overviewPageTitle, setOverviewPageTitle] = useState("");
  const [addEmailHistory, setAddEmailHistory] = useState(false);
  const [addPhoneCall, setAddPhoneCall] = useState(false);
  const initialFieldValues = Object.fromEntries(
    (moduleData?.fields || []).map((field) => [field?.name, ""])
  );
  const [allData, setAllData] = useState([]);
  const [addDocument, setAddDocument] = useState(false);
  const [moduleDataMap, setModuleDataMap] = useState({});
  const [accountsModuleId, setAccountsModuleId] = useState(null);
  const [dealsModuleId, setDealsModuleId] = useState(null);
  const [initialValues, setInitialValues] = useState({
    ...initialFieldValues,
    createBy: JSON.parse(localStorage.getItem("user"))._id,
  });
  const emailDataColumns = [
    { Header: crmConstant.sender, accessor: "senderName" },
    { Header: crmConstant.recipient, accessor: "createByName" },
    { Header: crmConstant.timeStamp, accessor: "timestamp" },
    { Header: crmConstant.createdAt, accessor: "createBy" },
  ];
  const callDataColumns = [
    { Header: crmConstant.callSubject, accessor: "subject" },
    { Header: crmConstant.callType, accessor: "callType" },
    { Header: crmConstant.timeStamp, accessor: "timestamp" },
    { Header: crmConstant.createdAt, accessor: "createBy" },
  ];

  const taskColumns = [
    { Header: crmConstant.title, accessor: "title" },
    { Header: crmConstant.category, accessor: "category" },
    { Header: crmConstant.assignTo, accessor: "assignmentToName" },
    { Header: crmConstant.TASK_HEADERS.START_DATE, accessor: "start" },
    { Header: crmConstant.TASK_HEADERS.END_DATE, accessor: "end" },
  ];
  const meetingColumns = [
    { Header: crmConstant.MEETING_HEADERS.AGENDA, accessor: "agenda" },
    { Header: crmConstant.MEETING_HEADERS.LOCATION, accessor: "location" },
    { Header: crmConstant.MEETING_HEADERS.RELATED, accessor: "related" },
    { Header: crmConstant.MEETING_HEADERS.DATE_TIME, accessor: "startDate" },
  ];
  const accountDataColumns = [
    { Header: crmConstant.accountName, accessor: "accountName" },
    { Header: crmConstant.industry, accessor: "industry" },
    { Header: crmConstant.annualRevenue, accessor: "annualRevenue" },
    { Header: crmConstant.accountStatus, accessor: "accountStatus" },
  ];
  const dealDataColumns = [
    { Header: crmConstant.dealName, accessor: "dealName" },
    { Header: crmConstant.stage, accessor: "stage" },
    { Header: crmConstant.amount, accessor: "amount" },
  ];

  const contactDataColumns = [
    { Header: crmConstant.contactName, accessor: "contactName" },
    { Header: crmConstant.companyName, accessor: "companyName" },
    { Header: crmConstant.emailAddress, accessor: "email" },
    { Header: crmConstant.jobTitle, accessor: "jobTitle" },
  ];
  // const fetchData = async (id) => {
  //   setIsLoading(true);
  //   let result = await getApi(`api/form?moduleId=${id}`);
  //   if (result.status === 200) {
  //     setData(result?.data?.data);
  //     setIsLoading(false);
  //   }
  // };

  // Reset state when module or ID changes
  const resetComponentState = () => {
    setData(null)
    setAllData([])
    setInitialValues({
      ...initialFieldValues,
      createBy: JSON.parse(localStorage.getItem("user"))._id,
    })
    setOverviewPageTitle("")
    setContactList([])
    setModelTableData({
      accounts: [],
      deals: [],
    })
  }

  const fetchData = async (id, isLoading) => {
    try {
      setIsLoading(isLoading);

      let result;

      if (id) {
        result = await getApi(`api/form?moduleId=${id}`);
      } else if (param.id) {
        result = await getApi(
          `api/form/view/${param.id}?moduleId=${module?._id}`
        );
        const responseData = result.data.data;
        const nameKey = Object.keys(responseData).find((key) =>
          key.toLowerCase().includes("name")
        );
        const overviewTitle = nameKey ? responseData[nameKey] : "-";
        setOverviewPageTitle(overviewTitle);
        setAllData(result?.data);
      }

      if (result?.status === 200) {
        setData(result?.data?.data);
        let editData = result?.data?.data;
        setInitialValues((prev) => ({ ...prev, ...editData }));
      }
    } catch (e) {
      toast.error(constant.somethingWentWrong);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const payload = {
        moduleId: moduleId.length > 0 ? moduleId : "",
        ids: [param.id],
      };
      let response = await deleteManyApi("api/form/deleteMany", payload);
      if (response.status === 200) {
        setDelete(false);
        setAction((pre) => !pre);
        navigate(pathName(module?.moduleName));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const [
    permission,
    taskPermission,
    meetingPermission,
    callAccess,
    emailAccess,
    taskAccess,
    meetingAccess,
  ] = HasAccess([
    "Leads",
    "Tasks",
    "Meetings",
    "Calls",
    "Emails",
    "Tasks",
    "Meetings",
  ]);



  const download = async (data) => {
    if (data) {
      let result = await getApi(`api/document/download/`, data);
      if (result && result.status === 200) {
        window.open(`${constant.baseUrl}api/document/download/${data}`);
        toast.success("file Download successful");
      } else if (result && result.response.status === 404) {
        toast.error("file Not Found");
      }
    }
  };
  const [modelTableData, setModelTableData] = useState({
    accounts: [],
    deals: [],
  });
  const [modalAction, setModalAction] = useState(false);
  const contactDataList = useSelector((state) => state?.contactLead?.contacts)
  const [isDynamicModelLoading, setIsDynamicModelLoading] = useState(false);

  const fetchCustomData = async () => {
    const response = await getApi(
      `api/custom-field?moduleName=${module?.moduleName}`
    );
    setLeadData(response.data);
  };
  const fetchDynamicData = async (id, type) => {
    setIsDynamicModelLoading(true);
    let result = await getApi(`api/form?moduleId=${id}`);
    if (result.status === 200) {
      if (type === crmConstant.accounts) {
        setModelTableData((prev) => ({
          ...prev,
          accounts: result?.data?.data,
        }));
      } else if (type === crmConstant.deals) {
        setModelTableData((prev) => ({ ...prev, deals: result?.data?.data }));
      }
      setIsDynamicModelLoading(false);
    }
  };
  const fetchCustomDataFields = async (type) => {
    try {
      setIsDynamicModelLoading(true);
      const result = await getApi(`api/custom-field/?moduleName=${type}`);
      if (result?.data) {
        const singaleData = result?.data?.find(
          (item) => item?.moduleName === type
        );
        const accountsModule = result?.data?.find(
          (item) => item?.moduleName === "Accounts"
        );
        const dealsModule = result?.data?.find(
          (item) => item?.moduleName === "Deals"
        );
        if (title === type) {
          setModuleData(singaleData);
        }
        setModuleDataMap((prev) => ({ ...prev, [type]: singaleData }));
        fetchDynamicData(singaleData?._id, type);

        const tempTableColumns = [
          { Header: "#", accessor: "_id", isSortable: false, width: 10 },
          ...(singaleData?.fields
            ?.filter((field) => field?.isTableField === true)
            ?.map((field) => ({
              Header: field?.label,
              accessor: field?.name,
              cell: (cell) => (
                <div className="selectOpt">
                  <Text
                    onClick={() => {
                      navigate(`/crm/${type}/${cell?.row?.original?._id}`, {
                        state: { module: singaleData },
                      });
                    }}
                    me="10px"
                    sx={{
                      "&:hover": {
                        color: "blue.500",
                        textDecoration: "underline",
                      },
                      cursor: "pointer",
                    }}
                    color="brand.600"
                    fontSize="sm"
                    fontWeight="700"
                  >
                    {cell?.value || "-"}
                  </Text>
                </div>
              ),
            })) || []),
        ];

        setSelectedColumns(tempTableColumns);
        setColumns(tempTableColumns);
        setTableColumns(tempTableColumns);
        if (accountsModule?._id) {
          setAccountsModuleId(accountsModule._id);
        }

        if (dealsModule?._id) {
          setDealsModuleId(dealsModule._id);
        }
      } else {
        console.error("No data found for module:", type);
      }
    } catch (error) {
      console.error("Error fetching custom data fields:", error);
    } finally {
      setIsDynamicModelLoading(false);
    }
  };
  const dispatch = useDispatch()
  async function getContactListData() {
    dispatch(getContactList({ fetchAllData: true }))
  }

  // Effect to handle route changes and reset state
  useEffect(() => {
    resetComponentState()
  }, [param.id, title])

  useEffect(() => {
    if (contactList.length > 0) {
      const updatedColumns = [
        { Header: "#", accessor: "_id", isSortable: false, width: 10 },
        {
          Header: "Contact Name",
          accessor: "contact",
          cell: ({ value }) => {
            const contact = contactList.find(
              (contact) => contact._id === value
            );
            return contact ? contact.name : "-";
          },
        },
      ];
      setColumns(updatedColumns);

      // setModuleData({
      //   name: "Contacts",
      // });
    }
  }, [contactList]);

  useEffect(() => {
    const fetchContacts = async () => {
      if (initialValues?.contact?.length > 0) {
        const allContacts = [];

        for (let id of initialValues.contact) {
          try {
            const response = await getApi(`api/contact/view/${id}`);
            if (response?.data) {
              allContacts.push(response.data);
            }
          } catch (error) {
            console.error(`Failed to fetch contact ${id}`, error);
          }
        }

        setContactList(allContacts);
      } else {
        setContactList([]);
      }
      if (initialValues?.deal?.length > 0) {
        fetchCustomDataFields("Deals");
      }
      if (initialValues?.account) {
        fetchCustomDataFields("Accounts");
      }
    };

    fetchContacts();
  }, [initialValues]);
  useEffect(() => {
    if (fetchCustomData) fetchCustomData();
  }, [action]);

  useEffect(() => {
    if (title && module) {
      getContactListData()
      fetchCustomDataFields(title)
      fetchData()
    }
  }, [param.id, title, module, action])

  async function onSubmitHandler(uniqueValues, id, selectedValues, type) {
    try {
      setIsModelDataSubmitLoading(true);

      let result;

      const normalizeToObject = (item) =>
        typeof item === "string" ? { _id: item } : item;

      const selectedItems = selectedValues.map(normalizeToObject);
      const itemIds = selectedItems.map((item) => item?._id);

      const postData = {
        moduleId: title === "Accounts" ? accountsModuleId : dealsModuleId,
        fieldName:
          type === crmConstant.deals
            ? "deal"
            : type === crmConstant.contacts
              ? "contact"
              : "account", // Field name dynamically chosen based on type
        data: itemIds,
      };

      result = await postApi(`api/form/addReference/${id}`, postData);

      if (result?.status === 200) {
        fetchData(false);
        onClose();
        setIsShowDynamicModel({ type: "", isShow: false });
      }
    } catch (e) {
      console.log(e, "from error");
      toast.error("Something went wrong");
    } finally {
      setIsModelDataSubmitLoading(false);
    }
  }

  useEffect(() => {
    setDataColumn(
      tableColumns?.filter((item) =>
        selectedColumns?.find((column) => column?.Header === item.Header)
      )
    );
  }, [tableColumns, selectedColumns]);
  const dealIds =
    initialValues.deal?.filter((id) =>
      modelTableData.deals?.some((deal) => deal._id === id)
    ) || [];

  return (
    <>
      {isLoading ? (
        <Flex justifyContent={"center"} alignItems={"center"} width="100%">
          {/* <Spinner /> */}
        </Flex>
      ) : (
        <>
          {/* <GridItem colSpan={{ base: 12, md: 6 }} mt={{ sm: "3px", md: "5px" }}>
            <Flex justifyContent={"right"}>
              <Menu>
                <MenuButton
                  size="sm"
                  variant="outline"
                  colorScheme="blackAlpha"
                  mr={2.5}
                  as={Button}
                  rightIcon={<ChevronDownIcon />}
                >
                  Actions
                </MenuButton>
                <MenuDivider />
                <MenuList minWidth={2}>
                  <MenuItem
                    color={"blue"}
                    onClick={() => onOpen()}
                    alignItems={"start"}
                    icon={<AddIcon />}
                  >
                    Add
                  </MenuItem>
                  <MenuItem
                    onClick={() => setEdit(true)}
                    alignItems={"start"}
                    icon={<EditIcon />}
                  >
                    Edit
                  </MenuItem>
                  <>
                    <MenuDivider />
                    <MenuItem
                      alignItems={"start"}
                      color={"red"}
                      onClick={() => setDelete(true)}
                      icon={<DeleteIcon />}
                    >
                      Delete
                    </MenuItem>
                  </>
                </MenuList>
              </Menu>
              <Link to={pathName(module.moduleName)}>
                <Button leftIcon={<IoIosArrowBack />} size="sm" variant="brand">
                  Back
                </Button>
              </Link>
            </Flex>
          </GridItem>
          <Box style={{ margin: "10px 0" }}>
            <CustomView data={module} fieldData={data} />
          </Box>
          <Card mt={3}>
            <Grid templateColumns="repeat(6, 1fr)" gap={1}>
              <GridItem colStart={6}>
                <Flex justifyContent={"right"}>
                  <Button
                    size="sm"
                    onClick={() => setEdit(true)}
                    leftIcon={<EditIcon />}
                    mr={2.5}
                    variant="outline"
                    colorScheme="green"
                  >
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    style={{ background: "red.800" }}
                    onClick={() => setDelete(true)}
                    leftIcon={<DeleteIcon />}
                    colorScheme="red"
                  >
                    Delete
                  </Button>
                </Flex>
              </GridItem>
            </Grid>
          </Card> */}
          <ViewEdit
            title={title}
            tabs={{
              Overview: (
                <>
                  <Overview
                    user={user}
                    dynamicModule={true}
                    permission={permission}
                    overviewPageTitle={overviewPageTitle}
                    menuSelectedDeleteItem={param.id}
                    handleDelete={handleDelete}
                    title={title}
                    getData={fetchData}
                    isDataLoding={isLoading}
                    setInitialValues={setInitialValues}
                    initialValues={initialValues}
                    isOpen={edit}
                    size={size}
                    onClose={setEdit}
                    setLeadData={setModuleData}
                    leadData={moduleData}
                    setAction={setAction}
                    isEdit={isEdit}
                    moduleId={moduleData?._id}
                  />
                  <GridItem mt={4} colSpan={{ base: 12, md: 12 }}>
                    <Card className="viewEditAccordianMainContainer">
                      <ColumnsTable
                        viewData={allData}
                        modalType={true}
                        setIsShowDynamicModel={(data) => {
                          fetchCustomDataFields(data.type);
                          setIsShowDynamicModel(data);
                        }}
                        addTitle={crmConstant.selectAccount.replace(
                          crmConstant.account,
                          crmConstant.contacts
                        )}
                        fetchData={fetchData}
                        emailAccess={emailAccess}
                        columnsData={contactDataColumns}
                        tableData={contactList
                          ?.map((item) => item.contact)
                          ?.filter(
                            (contact) =>
                              contact && Object.keys(contact).length > 0
                          )}
                        title="Contacts"
                        allData={allData}
                        moduleData={moduleDataMap.Contacts}
                      />

                      <DynamicModel
                        isModelDataSubmitLoading={isModelDataSubmitLoading}
                        onClose={() => {
                          setIsShowDynamicModel({ type: "", isShow: false });
                        }}
                        isOpen={
                          isShowDynamicModel.isShow &&
                          isShowDynamicModel.type === crmConstant.contacts
                        }
                        id={param.id}
                        title={crmConstant.contacts}
                        isLoading={isDynamicModelLoading}
                        moduleData={moduleData}
                        columns={columns}
                        onSubmitHandler={(uniqueValues, id, data) => {
                          onSubmitHandler(
                            uniqueValues,
                            id,
                            data,
                            crmConstant.contacts
                          );
                        }}
                        modalTitle={crmConstant.selectAccount.replace(
                          crmConstant.account,
                          crmConstant.contacts
                        )}
                        permission={permission}
                        selectedColumns={selectedColumns}
                        setSelectedColumns={setSelectedColumns}
                        setModalAction={setModalAction}
                        modalAction={modalAction}
                        dataColumn={dataColumn}
                        dynamicModule={contactList}
                        interestProperty
                        tableData={(contactDataList || []).filter(
                          (contact) =>
                            contact &&
                            Object.keys(contact).length > 0 &&
                            initialValues.contact?.includes(contact._id)
                        )}

                        data={(contactDataList || []).filter(
                          (contact) =>
                            contact && Object.keys(contact).length > 0
                        )}
                        isSingleSelectionOnly={false}
                      />
                    </Card>
                  </GridItem>
                  {/* account */}
                  {title !== "Accounts" && (
                    <GridItem mt={4} colSpan={{ base: 12, md: 12 }}>
                      <Card className="viewEditAccordianMainContainer">
                        <ColumnsTable
                          viewData={allData}
                          modalType={true}
                          setIsShowDynamicModel={(data) => {
                            fetchCustomDataFields(data.type);
                            setIsShowDynamicModel(data);
                          }}
                          addTitle={crmConstant.selectAccount}
                          fetchData={fetchData}
                          emailAccess={emailAccess}
                          columnsData={accountDataColumns}
                          tableData={
                            Array.isArray(allData.account)
                              ? allData.account.filter(
                                (acc) => acc._id === initialValues.account
                              )
                              : allData.account &&
                                allData.account._id === initialValues.account
                                ? [allData.account]
                                : []
                          }
                          title={"Accounts"}
                          allData={allData}
                          moduleData={moduleDataMap.Accounts}
                        />
                        <DynamicModel
                          isModelDataSubmitLoading={isModelDataSubmitLoading}
                          onClose={() => {
                            setIsShowDynamicModel({ type: "", isShow: false });
                          }}
                          isOpen={
                            isShowDynamicModel.isShow &&
                            isShowDynamicModel.type === crmConstant.accounts
                          }
                          id={param.id}
                          title={crmConstant.accounts}
                          isSingleSelectionOnly={true}
                          isLoading={isDynamicModelLoading}
                          moduleData={moduleData}
                          columns={columns}
                          onSubmitHandler={(uniqueValues, id, data) => {
                            onSubmitHandler(
                              uniqueValues,
                              id,
                              data,
                              crmConstant.accounts
                            );
                          }}
                          modalTitle={crmConstant.selectAccount.replace(
                            crmConstant.account,
                            crmConstant.account
                          )}
                          permission={permission}
                          selectedColumns={selectedColumns}
                          setSelectedColumns={setSelectedColumns}
                          data={modelTableData.accounts}
                          setModalAction={setModalAction}
                          modalAction={modalAction}
                          dataColumn={dataColumn}
                          dynamicModule={data?.account?._id}
                          interestProperty
                          tableData={
                            Array.isArray(allData.account)
                              ? allData.account.filter(
                                (acc) => acc._id === initialValues.account
                              )
                              : allData.account &&
                                allData.account._id === initialValues.account
                                ? [allData.account]
                                : []
                          }
                        ></DynamicModel>
                      </Card>
                    </GridItem>
                  )}
                  {/* deals */}
                  {title !== "Deals" && (
                    <GridItem mt={4} colSpan={{ base: 12, md: 12 }}>
                      <Card className="viewEditAccordianMainContainer">
                        <ColumnsTable
                          viewData={allData}
                          fetchData={fetchData}
                          setIsShowDynamicModel={(data) => {
                            fetchCustomDataFields(data.type);
                            setIsShowDynamicModel(data);
                          }}
                          addTitle={crmConstant.selectAccount.replace(
                            crmConstant.account,
                            crmConstant.deals
                          )}
                          emailAccess={emailAccess}
                          columnsData={dealDataColumns}
                          tableData={
                            Array.isArray(allData?.deals) ? allData.deals : []
                          }
                          title={crmConstant.deals}
                          modalType={true}
                          allData={allData}
                          moduleData={moduleDataMap.Deals}
                        />
                        <DynamicModel
                          isModelDataSubmitLoading={isModelDataSubmitLoading}
                          onClose={() => {
                            setIsShowDynamicModel({ type: "", isShow: false });
                          }}
                          isOpen={
                            isShowDynamicModel.isShow &&
                            isShowDynamicModel.type === crmConstant.deals
                          }
                          id={param.id}
                          title={crmConstant.deals}
                          isSingleSelectionOnly={false}
                          isLoading={isDynamicModelLoading}
                          moduleData={moduleData}
                          columns={columns}
                          onSubmitHandler={(uniqueValues, id, data) => {
                            onSubmitHandler(
                              uniqueValues,
                              id,
                              data,
                              crmConstant.deals
                            );
                          }}
                          modalTitle={crmConstant.selectAccount.replace(
                            crmConstant.account,
                            crmConstant.deals
                          )}
                          permission={permission}
                          selectedColumns={selectedColumns}
                          setSelectedColumns={setSelectedColumns}
                          data={
                            modelTableData.deals?.filter(
                              (deal) => !deal.account
                            ) || []
                          }
                          setModalAction={setModalAction}
                          modalAction={modalAction}
                          dataColumn={dataColumn}
                          dynamicModule={dealIds}
                          interestProperty
                          tableData={
                            modelTableData.deals?.filter((deal) =>
                              initialValues.deal?.includes(deal._id)
                            ) || []
                          }
                        />

                      </Card>
                    </GridItem>
                  )}
                </>
              ),
              ...(emailAccess?.view && {
                Emails: (
                  <GridItem colSpan={{ base: 12, md: 12 }}>
                    <Card className="viewEditAccordianMainContainer">
                      <ColumnsTable
                        fetchData={fetchCustomData}
                        viewData={allData}
                        emailAccess={emailAccess}
                        columnsData={emailDataColumns}
                        lead={false}
                        dynamic={true}
                        tableData={
                          allData?.emails?.length > 0 ? allData?.emails : []
                        }
                        title={"Emails"}
                        allData={allData}
                        isLead={true}
                        initialValues={allData.data}
                      />
                      <AddEmailHistory
                        viewData={allData}
                        fetchData={fetchCustomData}
                        isOpen={addEmailHistory}
                        onClose={setAddEmailHistory}
                        data={data?.contact}
                        setAction={setAction}
                        lead="true"
                        id={param.id}
                      />
                    </Card>
                  </GridItem>
                ),
              }),
              ...(callAccess?.view && {
                "Call Logs": (
                  <GridItem colSpan={{ base: 12, md: 12 }}>
                    <Card className="viewEditAccordianMainContainer">
                      <PhoneCall
                        callAccess={callAccess}
                        fetchData={fetchCustomData}
                        columnsData={callDataColumns}
                        lead={false}
                        dynamic={true}
                        tableData={
                          allData?.phoneCalls?.length > 0
                            ? allData?.phoneCalls
                            : []
                        }
                        title={"Call Logs"}
                        allData={allData}
                        isLead={true}
                        initialValues={allData.data}
                      />
                      <AddPhoneCall
                        viewData={allData}
                        fetchData={fetchCustomData}
                        isOpen={addPhoneCall}
                        onClose={setAddPhoneCall}
                        setAction={setAction}
                        data={data?.contact}
                        id={param.id}
                        lead="true"
                      />
                    </Card>
                  </GridItem>
                ),
              }),
              ...(taskAccess?.view && {
                Tasks: (
                  <GridItem colSpan={{ base: 12, md: 12 }}>
                    <Card className="viewEditAccordianMainContainer">
                      <TaskColumnsTable
                        fetchData={fetchCustomData}
                        columnsData={taskColumns}
                        lead={false}
                        dynamic={true}
                        tableData={
                          allData?.tasks?.length > 0 ? allData?.tasks : []
                        }
                        title={"Tasks"}
                        action={action}
                        setAction={setAction}
                        access={taskAccess}
                        allData={allData}
                        isLead={true}
                        initialValues={allData.data}
                      />
                    </Card>
                  </GridItem>
                ),
              }),
              ...(meetingAccess?.view && {
                Meetings: (
                  <GridItem colSpan={{ base: 12, md: 12 }}>
                    <Card className="viewEditAccordianMainContainer">
                      <MeetingColumnsTable
                        fetchData={fetchCustomData}
                        columnsData={meetingColumns}
                        lead={false}
                        dynamic={true}
                        tableData={
                          allData?.meetings?.length > 0 ? allData?.meetings : []
                        }
                        title={"Meetings"}
                        action={action}
                        setAction={setAction}
                        access={meetingAccess}
                        allData={allData}
                        initialValues={allData.data}
                      />
                    </Card>
                  </GridItem>
                ),
              }),

              ...((title === crmConstant.accounts ||
                title === crmConstant.deals) && {
                Attachments: (
                  <Attachment
                    textColor={textColor}
                    allData={allData}
                    download={download}
                    setAction={setAction}
                    addDocument={addDocument}
                    component={title}
                    fetchNewData={fetchData}
                    setAddDocument={setAddDocument}
                  />
                ),
              }),
            }}
            backRoute={pathName(module?.moduleName)}
          />
        </>
      )}
    </>
  );
};

export default View;
